import { createContext, useContext, useMemo } from 'react';
const defaultValue = {
  auth: undefined,
  standaloneTracker: undefined
};
export const XrayPanelContext = /*#__PURE__*/createContext(defaultValue);
const useScopes = () => {
  const {
    auth
  } = useContext(XrayPanelContext);
  if (!auth) {
    return [];
  }
  return auth.user.scopes;
};
export const useSelectHasScope = scopeToCheck => {
  const scopes = useScopes();
  return useMemo(() => scopes.includes(scopeToCheck), [scopes, scopeToCheck]);
};